import React, { Component, Suspense, useEffect } from 'react';
import { BrowserRouter, Redirect, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { UserContext } from '../contexts/UserContext';

import { allFlattenRoutes as routes } from './index';
import * as layoutConstants from '../constants/layout';

// All layouts/containers
import AuthLayout from '../layouts/Auth';
import VerticalLayout from '../layouts/Vertical';
import HorizontalLayout from '../layouts/Horizontal';
import DetachedLayout from '../layouts/Detached';
import Loader from '../components/Loader';
import ScrollToTop from '../components/ScrollToTop';
import ChunkErrorBoundary from '../utility-components/ChunkErrorBoundary';


class Routes extends Component {

    static contextType = UserContext;
    getLayout = () => {
        if (!this.context.faciToken) return AuthLayout;

        let layoutCls = VerticalLayout;

        switch (this.props.layout.layoutType) {
            case layoutConstants.LAYOUT_HORIZONTAL:
                layoutCls = HorizontalLayout;
                break;
            case layoutConstants.LAYOUT_DETACHED:
                layoutCls = DetachedLayout;
                break;
            default:
                layoutCls = VerticalLayout;
                break;
        }
        return layoutCls;
    };

    shouldComponentUpdate(nextProps, nextState) {
        let oldLayout = { ...this.props.layout };
        delete oldLayout.showRightSidebar;
        let newLayout = { ...nextProps.layout };
        delete newLayout.showRightSidebar;
        return (
            JSON.stringify(oldLayout) !== JSON.stringify(newLayout) ||
            JSON.stringify(this.props.user) !== JSON.stringify(nextProps.user)
        );
    }

    render() {
        const Layout = this.getLayout();
        // rendering the router with layout
        return (
            this.context.userLoading ?
            <Loader />
            :
            <Layout {...this.props}>
                 <ScrollToTop />
                <ChunkErrorBoundary>
                <Suspense fallback={<Loader />}>
                <Switch>
                    {routes.map((route, index) => {
                        // Skip parent routes that have children (they're just for menu structure)
                        // Only render leaf routes (routes without children)
                        // Exception: render parent routes with children only if they're exact (for redirects)
                        const hasChildren = route.children && route.children.length > 0;
                        const shouldRender = !hasChildren || (hasChildren && route.exact);
                        
                        return (
                            shouldRender && (
                                <route.route
                                    key={index}
                                    path={route.path}
                                    roles={route.roles}
                                    name={route.name}
                                    exact={route.exact}
                                    component={route.component}></route.route>
                            )
                        );
                    })}
                    <Redirect to="/dashboard" />
                </Switch>
                </Suspense>
                </ChunkErrorBoundary>
            </Layout>
        );
    }
}

const mapStateToProps = state => {
    return {
        layout: state.Layout,
        user: state.Auth.user,
    };
};

export default connect(
    mapStateToProps,
    null
)(Routes);
